import axios from "axios";
import { getAuthHeader } from "../../utils";
import customAxios from "../../customHook/customAxios";

export const v3_createNewBuildingPreLaunchingCheckListFields = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-launching-check-list/fields`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_fetchNewBuildingPreLaunchingCheckListFields = async (projectId, shipId) => {
    const params = new URLSearchParams({ _: String(Date.now()) });
    if (projectId && shipId) {
        params.set('projectId', projectId);
        params.set('shipId', shipId);
    }
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-launching-check-list/fields?${params.toString()}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_submitNewBuildingPreLaunchingCheckList = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-launching-check-list/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_NewBuildingPreLaunchingCheckList = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-launching-check-list/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_createNewBuildingPreDeliveryCheckListFields = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-delivery-check-list/fields`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetchNewBuildingPreDeliveryCheckListFields = async (projectId, shipId) => {
    const params = new URLSearchParams({ _: String(Date.now()) });
    if (projectId && shipId) {
        params.set('projectId', projectId);
        params.set('shipId', shipId);
    }
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-delivery-check-list/fields?${params.toString()}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_submitNewBuildingPreDeliveryCheckList = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-delivery-check-list/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_NewBuildingPreDeliveryCheckList = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-delivery-check-list/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}





export const v3_createNewBuildingPreSeaTrialCheckListFields = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-sea-trial-check-list/fields`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetchNewBuildingPreSeaTrialCheckListFields = async (projectId, shipId) => {
    const params = new URLSearchParams({ _: String(Date.now()) });
    if (projectId && shipId) {
        params.set('projectId', projectId);
        params.set('shipId', shipId);
    }
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-sea-trial-check-list/fields?${params.toString()}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_submitNewBuildingPreSeaTrialCheckList = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-sea-trial-check-list/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_NewBuildingPreSeaTrialCheckList = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-pre-sea-trial-check-list/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}






export const v3_createNewBuildingFinalDeliveryDocumentChecksheetFields = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-final-delivery-document-check-sheet/fields`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetchNewBuildingFinalDeliveryDocumentChecksheetFields = async (projectId, shipId) => {
    const params = new URLSearchParams({ _: String(Date.now()) });
    if (projectId && shipId) {
        params.set('projectId', projectId);
        params.set('shipId', shipId);
    }
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-final-delivery-document-check-sheet/fields?${params.toString()}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_submitNewBuildingFinalDeliveryDocumentChecksheet = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-final-delivery-document-check-sheet/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_NewBuildingFinalDeliveryDocumentChecksheet = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-final-delivery-document-check-sheet/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitNewBuildingBlockInspectionStatus = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-block-inspection-status/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_NewBuildingBlockInspectionStatus = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-block-inspection-status/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetchNewBuildingBlockInspectionStatusFields = async (projectId, shipId) => {

    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-block-inspection-status/fields${projectId && shipId ? `?projectId=${projectId}&shipId=${shipId}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitNewBuildingConfirmationOfVesselCompletionAndDelivery = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-confirmation-of-vessel-completion-and-delivery/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_NewBuildingConfirmationOfVesselCompletionAndDelivery = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-confirmation-of-vessel-completion-and-delivery/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetchNewBuildingConfirmationOfVesselCompletionAndDeliveryFields = async (projectId, shipId) => {

    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-confirmation-of-vessel-completion-and-delivery/fields${projectId && shipId ? `?projectId=${projectId}&shipId=${shipId}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_NewBuildingDailyInspectionReport = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-daily-inspection-report/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitNewBuildingDailyInspectionReport = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-daily-inspection-report/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_fetchNewBuildingDailyInspectionReport = async (projectId, shipId) => {

    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-daily-inspection-report/fields${projectId && shipId ? `?projectId=${projectId}&shipId=${shipId}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_submitNewBuildingNCRIndex = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-ncr-index/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_NewBuildingNCRIndex = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-ncr-index/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetchNewBuildingNCRIndexFields = async (projectId, shipId) => {

    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-ncr-index/fields${projectId && shipId ? `?projectId=${projectId}&shipId=${shipId}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitWeeklyTimeSheet = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/weekly-time-sheet/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fetchWeeklyTimeSheetFields = async (projectId, id) => {

    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/weekly-time-sheet/fields${projectId && id ? `?projectId=${projectId}&id=${id}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v3_WeeklyTimeSheet = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/weekly-time-sheet/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitNewBuildingNCR = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-ncr/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_NewBuildingNCRForm = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-ncr/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fetchNewBuildingNCRFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/new-building-ncr/fields?id=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_upload_owner_defect_report_photo = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/owner-defect-report/file`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_submitNewBuildingOwnerDefectReport = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/owner-defect-report/submission`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_NewBuildingOwnerDefectReport = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/owner-defect-report/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fetchNewBuildingOwnerDefectReportFields = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/owner-defect-report/fields?formId=${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

// --- Server-side report endpoints (PDF/DOC download, inline preview, mail) ---

export const v3_production_form_report_download_url = (formCode, formId, reportType = 'pdf') =>
    `${process.env.REACT_APP_BASE_URL}/v3/production-form/report/download/${reportType}/${encodeURIComponent(formCode)}/${formId}`;

export const v3_production_form_report_preview_url = (formCode, formId) =>
    `${process.env.REACT_APP_BASE_URL}/v3/production-form/report/preview/${encodeURIComponent(formCode)}/${formId}`;

export const v3_production_form_send_report_mail = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/report/mail`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

// Soft delete of a submitted form. One endpoint for all 11 Production forms;
// the API resolves formCode to its submission and log tables.
export const v3_delete_production_form = async (formCode, formId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/production-form/${encodeURIComponent(formCode)}/${formId}`;
    return customAxios.delete(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
